export function Details() {
  return (
    <></>
  )
}